import { types } from "../../reducers/types";
import axios from "axios";
import { store } from "../../App";
import { URL } from "../../api/tklEnvironments";
import {
  hideLoader,
  showFirstValidationErrorFromAPI,
  userRoles,
  isFreeUser,
} from "../../components/utility/ReUsableFunctions";
import { addToCatalogCart } from "../CatalogActions/CatalogAction";
import { ApplyCodeToCourse } from "../CatalogueActions/CartActions";

export const registrationFormInitialState = () => {
  return (dispatch) => {
    dispatch({ type: types.REGISTRATION_APPLICATION_INITIAL_DATA });
  };
};

export const registrationFieldData = (payload) => {
  return async (dispatch) => {
    let apiSuccess = false;

    await axios
      .post(`${URL}/user-registration`, payload)
      .then(function (response) {
        dispatch({ type: types.REGISTRATION_FORM_DATA, payload });
        apiSuccess = true;
        dispatch({
          type: types.REGISTRATION_FORM_DATA,
          payload: response.data?.response?.user,
        });
      })
      .catch(function (error) {
        let errorMessage = error?.response?.data?.errors;
        if (
          errorMessage?.password &&
          errorMessage.password[0] ===
            "The given password has appeared in a data leak. Please choose a different password."
        ) {
          dispatch({
            type: types.API_ERROR,
            payload: "Please choose a strong password",
          });
        } else if (
          errorMessage?.email &&
          errorMessage.email[0] === "The email has already been taken."
        ) {
          dispatch({
            type: types.API_ERROR,
            payload: "The email has already been taken",
          });
        } else {
          dispatch({
            type: types.API_ERROR,
            payload: "User Data not submitted, please try again",
          });
          return Promise.reject(false);
        }
      });
    if (apiSuccess) {
      return Promise.resolve(true);
    }
  };
};

export const verifyEmailCode = (history, otpEmail, uniqueIdentifier) => {
  return async (dispatch) => {
    let apiPayload = {};
    apiPayload["verificationCode"] = +otpEmail;
    apiPayload["uuid"] = uniqueIdentifier;
    let apiSuccessMessage =
      store && store.getState().coursepath.apiSuccessMessage;

    await axios
      .post(`${URL}/verify`, apiPayload)
      .then(function (response) {
        let newUserData = response.data?.response?.user;
        newUserData["accessToken"] = response.data?.response?.accessToken;
        localStorage.setItem("token", response.data?.response?.accessToken);
        dispatch({
          type: types.REGISTRATION_FORM_DATA,
          payload: newUserData,
        });
        localStorage.setItem(
          "userRole",
          JSON.stringify(response.data.response?.user?.roles)
        );
        let postId = +sessionStorage.getItem("bookmarkPostId");
        if (postId) {
          // sessionStorage.removeItem("bookmarkPostId");
          history.push(`/community/PostItem/${postId}`);
          history.go(0);
        } else if (localStorage.getItem("cartData")) {
          dispatch(
            transformExternalCartDaatToInternalByApi(
              JSON.parse(localStorage.getItem("cartData"))
            )
          ).then(() => {
            history.push("/toCart");
            history.go(0);
            // localStorage.removeItem("cartData");
          });
        } else {
          if (
            response.data.response?.user?.roles?.length === 1 &&
            response.data.response?.user?.roles.includes(
              userRoles?.TKL_MEMBER_FREE_USER
            )
          ) {
            setTimeout(() => {
              dispatch({
                type: types.API_SUCCESS,
                payload: "Registration Successful",
                pathName: "/community",
              });
            }, 0);
          } else {
            setTimeout(() => {
              dispatch({
                type: types.API_SUCCESS,
                payload: "Registration Successful",
                // pathName: "/createProfile",
                pathName: "/",
              });
            }, 0);
          }
        }
      })
      .catch(function (error) {
        dispatch({
          type: types.API_ERROR,
          payload: "Invalid Verification Code, Please try again",
        });
        return Promise.reject(false);
      });
    return Promise.resolve(true);
  };
};

export const reSendVerificationCode = (uuid, email, firstName) => {
  return async (dispatch) => {
    let initialTime = performance.now();
    dispatch({ type: types.SHOW_LOADER });
    let apiPayload = {};
    apiPayload["uuid"] = uuid;
    await axios
      .post(`${URL}/resend-verification-code`, apiPayload)
      .then(function (response) {
        hideLoader(initialTime);
        dispatch({
          type: types.API_SUCCESS,
          // payload: `<p>Dear user, you will be receiving a verification code over <b>${email}</b>. If you don't receive the verification code within 10-15 minutes, then please make sure that you check your spam folder.<p>`,
          payload: `<p>Dear <b>${firstName}</b>, you will be receiving a verification code to the following provided email address <b>${email}</b> in the next few minutes. 
          Use the verification code provided to complete your registration process. Please make sure to check your spam folder if you do not see the message within the next 10-15 minutes.<p>
          <p>Please feel free to contact us at <a href="mailto:PD@TeachnKidsLearn.com" target="_blank">PD@TeachnKidsLearn.com</a>
          with any registration issue.</p>
          `,
        });
      })
      .catch(function (error) {
        hideLoader(initialTime);
        dispatch({
          type: types.API_ERROR,
          payload: "Error in sending verification Code, Please try again",
        });
      });
  };
};

export const sendResetLink = (history, userEmail, firstName) => {
  return async (dispatch) => {
    let initialTime = performance.now();
    dispatch({ type: types.SHOW_LOADER });
    let payload = {};
    payload["email"] = userEmail;
    axios
      .post(`${URL}/forgot-password`, payload)
      .then(function (response) {
        hideLoader(initialTime);
        dispatch({
          type: types.API_SUCCESS,
          payload: `<p>Dear user, you will be receiving a link over <b>${userEmail}</b>. If you don't receive the link within 10-15 minutes, then please make sure that you check your spam folder.<p>
          <p>Please feel free to contact us at <a href="mailto:PD@TeachnKidsLearn.com" target="_blank">PD@TeachnKidsLearn.com</a>
          with any registration issue.</p>`,
        });
      })
      .catch(function (error) {
        hideLoader(initialTime);
        dispatch({
          type: types.API_ERROR,
          payload: "Incorrect email, please enter a valid email address",
        });
      });
  };
};

export const passwordReset = (history, userPwdData, uuid) => {
  return async (dispatch) => {
    let initialTime = performance.now();
    dispatch({ type: types.SHOW_LOADER });

    let payload = {};
    payload["password"] = userPwdData?.newPassword;
    payload["confirmPassword"] = userPwdData?.confirmPassword;
    payload["uuid"] = uuid;

    await axios
      .put(`${URL}/password-reset`, payload)
      .then(function (response) {
        hideLoader(initialTime);
        dispatch({
          type: types.API_SUCCESS,
          payload: `Password updated`,
        });
        history.push("/loginPage");
      })
      .catch(function (error) {
        hideLoader(initialTime);
        dispatch({
          type: types.API_ERROR,
          payload: "Please try again",
        });
      });
  };
};

export const loginUser = (history, userData) => {
  return async (dispatch) => {
    await axios
      .post(`${URL}/login`, userData)
      .then(function (response) {
        dispatch({
          type: types.ASSIGN_TOKEN,
          payload: response.data.response.token,
        });
        dispatch({
          type: types.ASSIGN_USER_ROLE,
          payload: response.data.response?.userData?.roles,
        });
        localStorage.setItem("token", response.data.response.token);
        try {
          localStorage.setItem(
            "isTemporaryPassword",
            response?.data?.response?.userData?.isTemporaryPassword
          );
          localStorage.setItem(
            "userRole",
            JSON.stringify(response.data.response?.userData?.roles)
          );
          let postId = +sessionStorage.getItem("bookmarkPostId");
          if (postId) {
            history.push(`/community/PostItem/${postId}`);
            history.go(0);
          } else if (localStorage.getItem("informationSheets")) {
            history.push("/");
            history.push(
              `/informationSheets?slug=${localStorage.getItem(
                "informationSheets"
              )}`
            );
            setTimeout(() => {
              history.go(0);
            }, 0);
          } else if (localStorage.getItem("cartData")) {
            dispatch(
              transformExternalCartDaatToInternalByApi(
                JSON.parse(localStorage.getItem("cartData"))
              )
            ).then((bool) => {
              // console.log("....bool", bool);
              setTimeout(() => {
                history.push("/toCart");
                history.go(0);
                localStorage.removeItem("cartData");
              }, 300);
            });
          } else {
            if (response?.data?.response?.userData?.isTemporaryPassword) {
              setTimeout(() => {
                history.push("/changeTempPassword");
                history.go(0);
              }, 500);
            } else {
              setTimeout(() => {
                if (isFreeUser(response.data.response?.userData?.roles)) {
                  history.push("/community");
                  history.go(0);
                } else {
                  history.push("/");
                  history.go(0);
                }
              }, 500);
            }
          }
        } catch (e) {
          console.log("login partial success", e);
          history.push("/");
          history.go(0);
        }
      })
      .catch(function (error) {
        console.log("error, ", error);
        let message =
          "The username and password do not match our records. Please try again. If this issue continues please contact us at PD@TeachnKidsLearn.com."; //"Invalid Credentials";

        if (error.response?.status === 403) {
          dispatch({
            type: types.API_ERROR,
            payload: "Incorrect email or password",
          });
        } else if (error.response?.data?.errors) {
          message = showFirstValidationErrorFromAPI(
            error.response?.data?.errors
          );
          dispatch({
            type: types.API_ERROR,
            payload: message,
          });
        } else {
          dispatch({
            type: types.API_ERROR,
            payload: message,
          });
        }
      });
  };
};

// export const transformExternalCartDaatToInternalByApi = (cartData) => {
//   return async (dispatch) => {
//     console.log("....1");
//     var addToCartCount = 0;
//     cartData.forEach((cartItem) => {
//       let payload = {
//         cohortDisplayId: cartItem?.cohortDisplayId,
//         cohortPurposeSlug: cartItem?.cohortPurposeSlug,
//         stateSlug: cartItem?.stateSlug,
//         type: cartItem?.type.toLowerCase(),
//       };
//       dispatch(addToCatalogCart(payload, true, true))
//         .then(() => {
//           console.log("....2");
//           ++addToCartCount;
//           if (cartItem?.codeApplied?.code) {
//             console.log(".....abcd");
//             if (cartItem?.codeApplied?.discountType) {
//               console.log(".....abcd2");

//               let codePayload = {
//                 code: cartItem?.codeApplied?.code,
//                 codeType: "discount",
//                 cohortDisplayIds: [cartItem?.cohortDisplayId],
//               };
//               dispatch(ApplyCodeToCourse(codePayload, cartData, true));
//             } else {
//               console.log(".....abcd3");

//               let codePayloadBundle = {
//                 code: cartItem?.codeApplied?.code,
//                 codeType: "bundle",
//                 cohortDisplayIds: [cartItem?.cohortDisplayId],
//               };
//               dispatch(ApplyCodeToCourse(codePayloadBundle, cartData, true));
//             }
//           }
//           console.log("..addToCartCount", addToCartCount, cartData?.length);
//           if (addToCartCount === cartData?.length) {
//             console.log("....addToCartCount");
//             return Promise.resolve();
//           }
//         })
//         .catch((error) => {
//           console.log("...error", error);
//           ++addToCartCount;
//           if (addToCartCount === cartData?.length) {
//             return Promise.resolve();
//           }
//         });
//     });
//   };
// };

export const transformExternalCartDaatToInternalByApi = (cartData) => {
  return async (dispatch) => {
    // console.log("....1");
    var addToCartCount = 0;
    let promisesAll = [];
    let payload = {};
    cartData.forEach((cartItem) => {
      if (cartItem?.type === "bundle") {
        payload = {
          bundleSlug: cartItem?.slug,
          type: cartItem?.type.toLowerCase(),
        };
      } else {
        payload = {
          cohortDisplayId: cartItem?.cohortDisplayId,
          cohortPurposeSlug: cartItem?.cohortPurposeSlug,
          stateSlug: cartItem?.stateSlug || "",
          type: cartItem?.type.toLowerCase(),
        };
      }
      promisesAll.push(
        dispatch(addToCatalogCart(payload, true, true))
          .then(async () => {
            if (cartItem?.codeApplied?.code) {
              if (cartItem?.codeApplied?.discountType) {
                let codePayload = {
                  code: cartItem?.codeApplied?.code,
                  codeType: "discount",
                  cohortDisplayIds: [cartItem?.cohortDisplayId],
                };
                await dispatch(
                  ApplyCodeToCourse(codePayload, cartData, true)
                ).then(() => {
                  //    console.log(".....discount addToCartCount", addToCartCount);
                  ++addToCartCount;
                  // if (addToCartCount === cartData?.length) {
                  //   return Promise.resolve();
                  // }
                });
              } else {
                let codePayloadBundle = {
                  code: cartItem?.codeApplied?.code,
                  codeType: "bundle",
                  cohortDisplayIds: [cartItem?.cohortDisplayId],
                };
                await dispatch(
                  ApplyCodeToCourse(codePayloadBundle, cartData, true)
                ).then(() => {
                  ++addToCartCount;
                  // if (addToCartCount === cartData?.length) {
                  //   return Promise.resolve();
                  // }
                });
              }
            } else {
              ++addToCartCount;
              // if (addToCartCount === cartData?.length) {
              //   return Promise.resolve();
              // }
            }
          })
          .catch((error) => {
            console.log("...error", error);
            ++addToCartCount;
            // if (addToCartCount === cartData?.length) {
            //   return Promise.resolve();
            // }
          })
      );
    });

    await Promise.all(promisesAll).then((response) => {
      return Promise.resolve(true);
    });
  };
};
